import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";
import Area from "components/Masters/Area";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import { log } from "console";

const Survey = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);

  const [route, setRoute] = useState([]);
  const [area, setArea] = useState([]);
  const [product, setProduct] = useState([
    { id: "abc", label: "abc" },
    { id: "bvd", label: "bvd" },
    { id: "abd", label: "abd" },
  ]);
  const [messageRow, setMessageRow] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );

  const routesRef: any = useRef(null);
  const areaRef: any = useRef(null);
  const productRef: any = useRef(null);
  const messageGridRef: any = useRef(null);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "date",
      name: LABELS.DATE,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "areaName",
      name: LABELS.AREA,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "routeName",
      name: LABELS.ROUTE,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "competitorProductsAvailable",
      name: LABELS.COMPETITOR_PRODUCTS_AVAILABLE,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "remarks",
      name: LABELS.REMARKS,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
    },

    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getCities();
    }
  }, [loading]);

  const getCities = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getCities(args).then((res: any) => {
      const response: any = res.response;
      console.log("Res", response);

      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.cityName,
          };
        });
        setArea(list);
        // getRows();
        getUsers();
      }
    });
  };

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;

      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setRoute(list);
        // getRows();
      }
    });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setMessageRow([]);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setMessageRow(JSON.parse(row.messages));
  };

  const reloadGrid = () => {
    setRows(null);
    loadGrid();
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    let loadErrors = [];

    if (fromDt === "") {
      loadErrors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      loadErrors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setGridLoading(false);
    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    setLoading(true);
    //TODO API IS STILL IN PROGRESS
    CUSTOMER_APIs.getSurveys(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const manageRecord = () => {
    const routeId = routesRef.current.selectedValue.id;
    const areaId = areaRef.current.selectedValue.id;
    const date = (
      document.getElementById("surveyDate") as HTMLInputElement
    ).value.trim();
    const product = productRef.current.selectedValue;
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();

    //todo:Validations needs to be done

    // Validations;
    let errors = [];
    if (!routeId) {
      errors.push({
        id: "routeId",
        msg:
          "<span class='bold'>" +
          LABELS.USER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!areaId) {
      errors.push({
        id: "areaId",
        msg:
          "<span class='bold'>" +
          LABELS.AREA +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      routeId,
      areaId,
      date,
      //   messages: messageGridRef.getRowData(),
      product,
      remarks,
    };

    console.log("args", args);
    setIsSubmit(true);
    setSelectedRow({});
    setManageDialog(false);
    reloadGrid();
    //TODO API IS STILL IN PROGRESS

    // CUSTOMER_APIs.manageSurvey(args).then((res) => {
    //   setIsSubmit(false);
    //   if (res.status === 200) {
    //     COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //     setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    //   } else {
    //     COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //   }
    // });
  };

  //   const getDeaultItemRow = () => {
  //     const newRow: any = {
  //       id: "1." + (messageGridRef.getRowData().length + 1).toString(),
  //     };
  //     return newRow;
  //   };

  console.log("Page: Competitor Survey:", messageRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.CRM_TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.COMPETITOR_SURVEY}</li>
        </ul>
        <h4>{TITLES.COMPETITOR_SURVEY}</h4>
        <p>{SUB_TITLES.COMPETITOR_SURVEY}</p>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 10,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadGrid}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryLoadResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryLoadResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {!gridLoading &&
          (rows ? (
            <ExcelGrid
              id={"survey"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.COMPETITOR_SURVEY}
              onReload={reloadGrid}
              onAdd={onAdd}
            />
          ) : (
            <div className="flexRowCenter">
              <Loader />
            </div>
          ))}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.COMPETITOR_SURVEY + ": " + selectedRow.areaName
              : "Add " + TITLES.COMPETITOR_SURVEY
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
            setMandatoryLoadResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup  ">
              <TxtRow
                id={"surveyDate"}
                label={LABELS.DATE}
                defaultValue={
                  selectedRow.surveyDate
                    ? DateFunctions.getFormatedDate(
                        selectedRow.surveyDate,
                        FORMATS.SQL_DATE_ONLY,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                type={"date"}
                // disabled={isSubmit}
              />
            </div>
            <div className="formGroup required ">
              <label>{LABELS.AREA}</label>
              {<span className="red">*</span>}
              <AutoComplete
                list={area}
                childRef={areaRef}
                defaultValue={
                  selectedRow.areaId
                    ? {
                        id: selectedRow.areaId,
                        label: selectedRow.areaName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                // disabled={isSubmit}
              />
            </div>
            <div className="formGroup required">
              <label>{LABELS.ROUTE}</label>
              {<span className="red">*</span>}
              <AutoComplete
                list={route}
                childRef={routesRef}
                defaultValue={
                  selectedRow.routeId
                    ? {
                        id: selectedRow.cityId,
                        label: selectedRow.cityName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                // disabled={isSubmit}
              />
            </div>

            <div className="formGroup ">
              <label>{LABELS.COMPETITOR_PRODUCTS_AVAILABLE}</label>
              <AutoComplete
                list={product}
                childRef={productRef}
                // defaultValue={
                //   selectedRow.productId
                //     ? {
                //         id: selectedRow.id,
                //         label: selectedRow.label,
                //       }
                //     : null
                // }
                onChange={(e, v) => {}}
                // disabled={isSubmit}
                multiple={true}
              />
            </div>
            <div className="formGroup  ">
              <TxtRow
                id={"remarks"}
                label={LABELS.REMARKS}
                // disabled={isSubmit}
              />
            </div>

            {/* mandatoryResults */}

            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                    setMandatoryLoadResults([]);
                  }}
                  //   loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageRecord}
                  //   loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(Survey);
